
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWindShaft12 as ObiWindShaft12Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-shaft-12.js';
 
 
 

 
 export const ObiWindShaft12 = createComponent({
   react: React,
   tagName: 'obi-wind-shaft-12',
   elementClass: ObiWindShaft12Element,
   events: {
     
   }
  });
 
 